import { GetterTree } from 'vuex'
import { ProfileState, UserData } from './types'
import { RootState } from '../types'
import { state } from '.'

export const getters: GetterTree<ProfileState, RootState> = {
  fullName (state): string {
    const { user } = state
    const name = (user && user.displayName) || ''
    const email = (user && user.email) || ''
    return `${name} (${email})`
  },
  firstname (): string {
    return ''
  },
  lastname (): string {
    return ''
  },
  salutation (): string {
    return ''
  },
  userData (): UserData {
    return state.data
  }
}
